console.log('animation.js LOADED (before listener)');

window.addEventListener('splash:finished', () => {
  console.log('[mainv] splash:finished received');
  startMainvTextAnim();
}, { once: true });

console.log('animation.js listener registered');



  function delayScrollAnime() {
    var timeStep = 0.2; // 1要素ごとの追加ディレイ秒
    $(".js-scroll").each(function () {
      var parent = this;
      // すでに一度発火したらスキップ
      if ($(parent).hasClass("is-animated")) return;

      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();

      // トリガー閾値（統一: 15%）
      var triggerOffset = windowHeight * 0.15;

      if (scroll >= elemPos - windowHeight + triggerOffset) {
        var value = timeStep;
        var childs = $(this).children();
        $(this).css("opacity", 1); // 親は見える状態へ
        $(childs).each(function () {
          $(this).css("animation-delay", value + "s");
          $(this).addClass("fadeUp");
          value += timeStep;
        });
        $(parent).addClass("is-animated"); // 一度だけ
      }
    });
  }

  // スクロール・ロード時（間引き）
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function () {
        delayScrollAnime();
        ticking = false;
      });
    }
  }
  $(window).on("scroll", onScroll);
  $(window).on("load", function () {
    delayScrollAnime();
  });

  // ========== 2) シンプルなフェード（show-fade） ==========
  function simpleFade() {
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    var triggerOffset = windowHeight * 0.15; // 統一: 15%

    $(".fade").each(function () {
      var imgPos = $(this).offset().top;
      if (scroll > imgPos - windowHeight + triggerOffset) {
        $(this).addClass("show-fade");
        // 繰り返し不要なら属性やフラグを付けて二度目以降の処理を避けてもOK
      }
    });
  }
  $(window).on("scroll", function () {
    requestAnimationFrame(simpleFade);
  });
  $(window).on("load", simpleFade);

  // ========== 3) 画像イン（show-img）SP/PC閾値切り替え ==========
  function imgIn() {
    var winW = $(window).width();
    var showH = winW <= 767 ? 100 : 300; // SP/PCで閾値を変更
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();

    $(".img-in img").each(function () {
      var imgPos = $(this).offset().top;
      if (scroll > imgPos - windowHeight + showH) {
        $(this).addClass("show-img");
      } else {
        // 一度だけなら外さない
        // $(this).removeClass("show-img");
      }
    });
  }
  $(window).on("scroll", function () {
    requestAnimationFrame(imgIn);
  });
  $(window).on("load resize", imgIn);

  // ========== 4) inViewトリガー（個別解除で統一） ==========
 if (typeof window.inView === 'function') {
  window.inView.offset(0.15 * window.innerHeight);

  window.inView('[data-inview]')
    .on('enter', el => {
      el.classList.add('is-inview');
      el.removeAttribute('data-inview');
    })
    .on('exit', el => {
      // 必要なら
    });

  window.addEventListener('resize', () => {
    window.inView.offset(0.15 * window.innerHeight);
  });
}

// data-delay属性で遅延指定（ms）※これは inView と無関係なので残す
document.querySelectorAll('.fade-in[data-delay]').forEach(el => {
  const d = parseInt(el.getAttribute('data-delay'), 10);
  if (!Number.isNaN(d)) el.style.transitionDelay = d + 'ms';
});


  //TOP GSAP
 function startMainvTextAnim() {
  console.log('[mainv] startMainvTextAnim called');

  if (window.__mainvTextAnimStarted) return;
  window.__mainvTextAnimStarted = true;

  console.log('[mainv] gsap:', !!window.gsap, 'ScrollTrigger:', !!window.ScrollTrigger, 'SplitType:', !!window.SplitType);

  if (!window.gsap) return;

  const wrap = document.querySelector('.p-mainv__txt');
  console.log('[mainv] wrap:', wrap);
  if (!wrap) return;

    wrap.style.visibility = 'visible';

  const h1 = wrap.querySelector('h1');
  const marker = wrap.querySelector('p.marker');
  console.log('[mainv] h1:', h1, 'marker:', marker);
  if (!h1 || !marker) return;

  if (!window.SplitType) {
    console.warn('[mainv] SplitType not found');
    return;
  }

  const split = new SplitType(h1, { types: 'chars' });

  gsap.set(marker, { '--mk': 0 });

  gsap.timeline({ defaults: { ease: 'power3.out' } })
    .fromTo(split.chars,
      { yPercent: 120, opacity: 0, rotateX: -70 },
      { yPercent: 0, opacity: 1, rotateX: 0, duration: 0.9, stagger: 0.03 }
    )
    .to(marker, { '--mk': 1, duration: 0.55, ease: 'power2.out' }, '-=0.35')
    .fromTo(marker, { y: 14, opacity: 0 }, { y: 0, opacity: 1, duration: 0.5 }, '-=0.45');
}

window.addEventListener('splash:finished', () => {
  console.log('[mainv] splash:finished received');
  startMainvTextAnim();
}, { once: true });

if (document.documentElement.classList.contains('is-splash-finished')) {
  console.log('[mainv] is-splash-finished already set');
  startMainvTextAnim();
}